SNI.Application.addModule('multi-content-stream', function(context) {

  return {
    behaviors: ['lazy-load', 'truncate']
  };

});
